(() => {
  if (customElements.get('vors-purchase-guide')) return;

  class VorsPurchaseGuide extends HTMLElement {
    connectedCallback() {
      // The summary sits in its own block above the buy buttons, so find the product form of the same section.
      const section = this.closest('.shopify-section') || document;
      this.form = this.closest('form') || section.querySelector('form.js-product-form');
      this.quantity = this.form ? this.form.querySelector('[name="quantity"]') : null;
      if (!this.quantity) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const refresh = () => this.update();

      // Typed quantity, the theme's plus and minus buttons, and variant changes all end up here.
      this.form.addEventListener('input', refresh, options);
      this.form.addEventListener('change', refresh, options);
      this.form.addEventListener('click', event => {
        if (event.target.closest('quantity-wrapper')) setTimeout(refresh, 0);
      }, options);

      // Fallback for a page where the inline default script did not run (for example a theme editor re-render).
      if (!this.form.dataset.vorsDefaultApplied) {
        this.form.dataset.vorsDefaultApplied = 'true';
        const wanted = Number(this.dataset.defaultQuantity) || 4;
        if (this.quantity.value === '' || Number(this.quantity.value) === 1) this.quantity.value = String(wanted);
      }

      // The total row lives under the add to cart button. Reuse the one already there (a variant change re-renders
      // this element but not the form), otherwise move our own row into place.
      const placed = this.form.querySelector('[data-vors-total-row]');
      const mine = this.querySelector('[data-vors-total-row]');
      if (placed && mine && placed !== mine) {
        mine.remove();
      } else if (mine && !placed) {
        const submit = this.form.querySelector('.quantity-submit-row__submit');
        if (submit) submit.insertAdjacentElement('afterend', mine);
        mine.hidden = false;
      }
      this.totalRow = this.form.querySelector('[data-vors-total-row]') || mine;

      this.update();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    update() {
      const q = Number(this.quantity.value);
      const min = Number(this.dataset.min) || 1;
      const increment = Number(this.dataset.increment) || 1;
      const max = this.dataset.max ? Number(this.dataset.max) : Infinity;
      const available = this.dataset.available ? Number(this.dataset.available) : Infinity;
      const valid = Number.isSafeInteger(q) && q >= min && q <= max && q % increment === 0;

      const total = this.totalRow ? this.totalRow.querySelector('[data-vors-total]') : null;
      const box = this.querySelector('[data-vors-stock]');
      const text = this.querySelector('[data-vors-stock-text]');
      const note = this.querySelector('[data-vors-stock-note]');

      if (!valid) {
        box.setAttribute('data-vors-stock', 'select');
        text.textContent = this.dataset.invalid;
        note.textContent = this.dataset.invalidNote;
        return;
      }

      if (total) total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      }).format(Number(this.dataset.unitPrice) * q / 100);

      if (q > available) {
        box.setAttribute('data-vors-stock', 'short');
        text.textContent = this.dataset.short.replace('[available]', String(Math.max(available, 0)));
        note.textContent = this.dataset.shortNote;
      } else {
        box.setAttribute('data-vors-stock', 'ready');
        text.textContent = (q === 1 ? this.dataset.readyOne : this.dataset.readyOther).replace('[quantity]', String(q));
        note.textContent = this.dataset.dispatch;
      }
    }
  }

  customElements.define('vors-purchase-guide', VorsPurchaseGuide);
})();
